import { styled } from 'linaria/react';

export const RoundedLinkContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 152px;
  margin-right: -0.1px;
  border-radius: var(--rounding-l);
  box-shadow: inset 0 0 1px rgb(0 0 0 / 60%);
  cursor: pointer;
  -webkit-mask-image: -webkit-radial-gradient(circle, black, white);
`;

export const LinkTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: var(--space-300);
`;
